import { get } from '../../../../infra/rest';
import { BulkChatAction, BulkOperationState, BulkOperationStatus } from '../typings/bulk-action-progress';
import { getCurrentUserId } from '../../../../infra/firebase/init';

interface BulkActionOperationRaw {
  operationId: string;
  dateCreated: string;
  action: string;
  status: string;
  total: number;
  succeeded: number;
  failed: number;
  validUserIds?: string[];
}

interface GetBulkActionOperationsResponse {
  operations: BulkActionOperationRaw[];
}

export async function getBulkActionOperations(): Promise<BulkOperationState[]> {
  const response = await get<GetBulkActionOperationsResponse>('/v2/conversation/bulk-action-operations', {}, true);
  const currentUserId = getCurrentUserId();
  const ops = response?.operations ?? [];
  return ops
    .filter((op) => op.status !== 'COMPLETE')
    .filter((op) => !currentUserId || !op.validUserIds || op.validUserIds.includes(currentUserId))
    .map((op) => ({
      operationId: op.operationId,
      status: op.status as BulkOperationStatus,
      action: op.action as BulkChatAction,
      total: op.total,
      succeeded: op.succeeded,
      failed: op.failed,
    }));
}
